
import { filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { FournisseursModel } from '../models/fournisseurs.model';
import { FournisseurType } from '../models/fournisseurs.enum';
import { NavigationEnd, Router } from '@angular/router';
import { HttpServices } from '../services/http.service';
import { ReferenceService } from '../services/reference.service';
import * as config from '../config/config';

@Injectable()
export class FournisseurService {
  private suppliersNb: number;
  private activeSupplierId: number;
  private activeSupplierChange = new Subject<any>();
  activeSupplierChange$ = this.activeSupplierChange.asObservable();
  private suppliersInfosList: FournisseursModel[];
  private suppliersInfosListChange = new Subject<FournisseursModel[]>();
  suppliersInfosListChange$ = this.suppliersInfosListChange.asObservable();

  constructor(
    private router: Router,
    private httpServices: HttpServices,
    private referenceService: ReferenceService,
  ) {
    router.events.pipe(
      filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (event.url.includes('balance-outstanding')) {
          this.applySpecificRule();
        }
      });
  }

  fetchFournisseurs(): Observable<FournisseursModel[]> {
    return this.httpServices.get<FournisseursModel[]>(
      this.referenceService.staticReferences.Action[config.ApiKeys.GET_FOURNISSEURS],
      () => { }
    );
  }

  initSuppliersInfos(suppliersInfosList: FournisseursModel[]) {
    this.suppliersNb = suppliersInfosList.length;
    this.suppliersInfosList = this.sortByImportance(this.modifyDCFLabel(suppliersInfosList));
    this.activeSupplierId = this.suppliersInfosList[0]?.FournisseurId ?? 0;
  }

  private applySpecificRule() {
    let index = 0;
    while (
      this.suppliersInfosList[index] &&
      this.suppliersInfosList[index].InvoiceToPayNumber === 0 &&
      index < this.suppliersNb
    ) {
      index++;
    }

    if (
      this.suppliersInfosList[index] &&
      this.suppliersInfosList[index].FournisseurId !== this.activeSupplierId
    ) {
      this.activeSupplierId = this.suppliersInfosList[index].FournisseurId;
    }
  }

  private modifyDCFLabel(suppliersList: FournisseursModel[]): FournisseursModel[] {
    const supplierDCF = suppliersList.find(supplier => supplier.FournisseurId === FournisseurType.DCF);
    if (supplierDCF) {
      supplierDCF.FournisseurNom = 'DCF';
    }
    return suppliersList;
  }

  private sortByImportance(suppliersList: FournisseursModel[]): FournisseursModel[] {
    return suppliersList.sort(
      function (supplierA: FournisseursModel, supplierB: FournisseursModel) {
        const tab = ['DCF', 'WEBIMM'];
        if (tab.indexOf(supplierA.FournisseurNom.toUpperCase()) < tab.indexOf(supplierB.FournisseurNom.toUpperCase())) {
          return -1;
        } else {
          return 1;
        }
      }
    );
  }

  getSuppliersNb(): number {
    return this.suppliersNb;
  }

  setSuppliersNb(value: number) {
    this.suppliersNb = value;
  }

  getActiveSupplierId(): number {
    return this.activeSupplierId;
  }

  setActiveSupplierId(supplierId: number) {
    this.activeSupplierId = supplierId;
    this.activeSupplierChange.next(supplierId);
  }

  getSuppliersInfosList(): FournisseursModel[] {
    return this.suppliersInfosList;
  }

  setSuppliersInfosList(suppliersList: FournisseursModel[]) {
    this.suppliersInfosList = suppliersList;
  }
}
